import productApi from '../api/product';
import optimizedPaintListApi from '../api/optimizedPaintList';
import orderApi from '../api/order';
import { showErrorMessage } from '../dialogs';

export function standardCallback(barcode) {
    const app = window.newVueApp;
    if (barcode.startsWith('PR') || barcode.startsWith('PG')) {
        productApi
            .validateProductExistence(barcode)
            .then((response) => {
                const product = response.data.data;
                if (product.isGroup == '1') {
                    app.$router.push('/productgrouppage/' + product.productId);
                } else {
                    app.$router.push('/productpage/' + product.productId);
                }
            })
            .catch(() => {
                showErrorMessage('Product niet gevonden!');
            });
    } else if (barcode.startsWith('O')) {
        orderApi
            .validateOrderExistance(barcode)
            .then(() => {
                app.$router.push(
                    '/editproduct/?orderId=' +
                        barcode +
                        '&productState=show-producttype'
                );
            })
            .catch(() => {
                showErrorMessage('Bestelling niet gevonden!');
            });
    } else if (barcode.startsWith('S')) {
        orderApi
            .validateServiceOrderExistance(barcode)
            .then(() => {
                app.$router.push(
                    '/editproduct/?orderId=' +
                        barcode +
                        '&productState=show-producttype'
                );
            })
            .catch(() => {
                showErrorMessage('Service order niet gevonden!');
            });
    } else if (barcode.startsWith('L')) {
        optimizedPaintListApi
            .validateExistence(barcode)
            .then(() => {
                app.$router.push(
                    '/work-post-paint-screen?paintListId=' + barcode
                );
            })
            .catch(() => {
                showErrorMessage('Lakbon niet gevonden!');
            });
    } else {
        showErrorMessage('Barcode niet gevonden!');
    }
}
